function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.555 18.117h15.271M2.555 13.913h15.271M13.074 9.709h4.755M15.457 5.503h2.378M11.39 2.137h6.443",
  stroke: "currentColor",
  strokeWidth: 1.273,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.445 1.37H2.223v11.222h11.223V1.369z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ai_text_svg__a)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.41 6.06l-2.081-.802c-.295-.115-.447-.17-.539-.24a.967.967 0 01-.216-.216c-.065-.092-.12-.225-.244-.548l-.797-2.076a.465.465 0 00-.428-.295.466.466 0 00-.433.295l-.797 2.076c-.124.323-.175.456-.244.548a.88.88 0 01-.216.217c-.092.069-.244.124-.544.24l-2.076.8a.458.458 0 00-.295.429c0 .193.115.363.295.428l2.076.801c.314.12.452.175.544.24a.88.88 0 01.216.216c.07.097.13.249.244.548l.797 2.077c.069.18.24.294.433.294.189 0 .359-.115.428-.294L9.33 8.72c.12-.3.175-.451.244-.548a.967.967 0 01.216-.217c.092-.064.226-.115.548-.239l2.072-.801c.18-.065.3-.235.3-.428 0-.19-.12-.36-.3-.429zM2.733 3.665h.765v.765c0 .28.225.51.51.51.28 0 .51-.23.51-.51v-.765h.766c.28 0 .51-.23.51-.51s-.23-.51-.51-.51h-.766v-.766c0-.28-.23-.51-.51-.51-.285 0-.51.23-.51.51v.765h-.765c-.286 0-.51.23-.51.51 0 .281.224.51.51.51zM5.284 9.798h-.766v-.765c0-.28-.23-.51-.51-.51-.285 0-.51.23-.51.51v.765h-.765c-.286 0-.51.23-.51.51s.224.51.51.51h.765v.765c0 .28.225.51.51.51.28 0 .51-.23.51-.51v-.765h.766c.28 0 .51-.23.51-.51s-.23-.51-.51-.51z"
}));

var SvgAiText = function SvgAiText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    color: "#543199"
  }, props), _ref, /*#__PURE__*/React.createElement("mask", {
    id: "ai_text_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 12,
    height: 12
  }, _ref2), _ref3);
};

export default SvgAiText;